export const formatDate = (dateString, format = 'en-GB') => {
  if (!dateString) return '';
  
  try {
    return new Date(dateString).toLocaleDateString(format);
  } catch (error) {
    console.error('Date formatting error:', error);
    return dateString;
  }
};

export const formatDateTime = (dateString, format = 'en-GB') => {
  if (!dateString) return '';
  
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString(format) + ' ' + 
           date.toLocaleTimeString(format, { hour: '2-digit', minute: '2-digit' });
  } catch (error) {
    console.error('DateTime formatting error:', error);
    return dateString;
  }
};

export const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes';
  
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

export const generateSerialNumber = (prefix = 'CERT') => {
  const timestamp = Date.now();
  const random = Math.floor(Math.random() * 1000);
  return `${prefix}${timestamp}${random}`;
};